import { forwardRef, useRef, useState, createElement, useEffect } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { Badge } from '../../display/Badge/Badge.es.js';
import { Tag } from '../../display/Tag/Tag.es.js';
import { Link } from '../Link/Link.es.js';
import { TabsDropdown } from './TabsDropdown.es.js';

const tabsRoot = "_tabs-root_t6mfx_1";
const primaryLinks = "_primary-links_t6mfx_15";
const item = "_item_t6mfx_24";
const itemText = "_item-text_t6mfx_55";
const badgeAndTag = "_badge-and-tag_t6mfx_81";
const badgeDisabled = "_badge-disabled_t6mfx_85";
const indicatorTrack = "_indicator-track_t6mfx_90";
const indicator = "_indicator_t6mfx_90";
const styles = {
	tabsRoot: tabsRoot,
	primaryLinks: primaryLinks,
	item: item,
	itemText: itemText,
	badgeAndTag: badgeAndTag,
	badgeDisabled: badgeDisabled,
	indicatorTrack: indicatorTrack,
	indicator: indicator
};

const TabsItem = (props) => {
  if (props.disabled) {
    return jsxs("button", { type: "button", "aria-label": props.ariaLabel, className: styles.item, disabled: true, "data-selected": props.isSelected ? true : void 0, "data-zds": true, children: [jsx("span", { className: styles.itemText, "data-zds": true, children: props.text }), props.badgeText && jsx(Badge, { className: clsx(styles.badgeAndTag, props.disabled && styles.badgeDisabled), variant: props.badgeVariant, children: props.badgeText }), props.tagText && jsx(Tag, { variant: props.tagVariant, className: clsx(styles.badgeAndTag, props.disabled && styles.badgeDisabled), children: props.tagText })] });
  }
  let isSelectedBadgeVariant = props.badgeVariant;
  switch (props.badgeVariant) {
    case "neutral":
      isSelectedBadgeVariant = "neutral-stronger";
      break;
    case "primary":
      isSelectedBadgeVariant = "primary-stronger";
      break;
    case "brand":
      isSelectedBadgeVariant = "brand-stronger";
      break;
    case "success":
      isSelectedBadgeVariant = "success-stronger";
      break;
    case "warning":
      isSelectedBadgeVariant = "warning-stronger";
      break;
    case "error":
      isSelectedBadgeVariant = "error-stronger";
      break;
  }
  return jsxs(Link, { "aria-label": props.ariaLabel, "aria-current": props.isSelected ? props.ariaCurrent : void 0, color: null, className: styles.item, "data-selected": props.isSelected ? true : void 0, href: props.href, onClick: props.onChoose, ref: props.forwardedRef, children: [jsx("span", { className: styles.itemText, "data-text": props.text, "data-zds": true, children: props.text }), props.badgeText && jsx(Badge, { className: clsx(styles.badgeAndTag, props.disabled && styles.badgeDisabled), variant: props.isSelected ? isSelectedBadgeVariant : props.badgeVariant, children: props.badgeText }), props.tagText && jsx(Tag, { variant: props.tagVariant, className: clsx(styles.badgeAndTag, props.disabled && styles.badgeDisabled), children: props.tagText })] });
};
const Tabs = forwardRef(({ items, selectedItemHref, "aria-label": ariaLabel = void 0, "aria-current": ariaCurrent = "page", isItemSelected = (item, selectedItemHref2) => item.href === selectedItemHref2, onChooseItem = () => {
}, shouldRenderTrack = true, size = "large", type = "default" }, ref) => {
  const selectedItemRef = useRef(null);
  const [indicatorStyles, setIndicatorStyles] = useState({});
  const shouldRenderIndicator = !items.every((i) => i.isExtra);
  const primaryItems = items.filter((item) => !item.isExtra);
  const primaryLinks = primaryItems.map((item) => {
    const isSelected = isItemSelected(item, selectedItemHref);
    return createElement(TabsItem, Object.assign({}, item, { ariaCurrent, forwardedRef: isSelected && shouldRenderIndicator ? selectedItemRef : null, isSelected, key: item.href, onChoose: (event) => onChooseItem(item, event), type }));
  });
  const secondaryItems = items.filter((item) => item.isExtra);
  const isSecondaryItemSelected = secondaryItems.some((item) => {
    return isItemSelected(item, selectedItemHref);
  });
  const secondaryMenu = secondaryItems.length > 0 && jsx("div", { ref: isSecondaryItemSelected && shouldRenderIndicator ? selectedItemRef : null, "data-zds": true, children: jsx(TabsDropdown, { size, items: secondaryItems, onChooseItem, selectedItemHref }) });
  const updateIndicatorPosition = () => {
    if (selectedItemRef.current) {
      setIndicatorStyles({
        left: selectedItemRef.current.offsetLeft,
        width: selectedItemRef.current.offsetWidth
      });
    }
  };
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      updateIndicatorPosition();
    });
    if (selectedItemRef.current) {
      resizeObserver.observe(selectedItemRef.current);
      requestAnimationFrame(updateIndicatorPosition);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, [items, selectedItemHref]);
  return jsxs("nav", { "aria-label": ariaLabel, className: styles.tabsRoot, "data-size": size, "data-zds": true, children: [jsx("div", { className: styles.primaryLinks, style: {
    "--_zds-tabs-link-count": primaryLinks.length
  }, ref, "data-zds": true, children: primaryLinks }), secondaryMenu, jsx("div", { className: styles.indicatorTrack, "data-render-track": shouldRenderTrack ? true : void 0, "data-zds": true, children: jsx("div", { className: styles.indicator, "data-variant": type, style: indicatorStyles, "data-zds": true }) })] });
});

export { Tabs };
//# sourceMappingURL=Tabs.es.js.map
